module.exports = __webpack_public_path__ + "static/img/uuid.b7b0264b.jpg";